var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "staff-management-settings-container" }, [
    _c("div", { staticClass: "title-table-staff-setting h2-text" }, [
      _vm._v("Staff Management")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "global-rate-of-pay-table" },
      [_c("GlobalRateOfPay", { attrs: { staffSettings: _vm.staffSettings } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38cc5678", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38cc5678","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalSettings/StaffManagement.vue
// module id = 2067
// module chunks = 1